import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback } from 'react';
import DeleteButton from './DeleteButton';
const styles = (styles) => css `
  position: relative;

  .delete {
    position: absolute;
    top: 2px;
    left: 2px;
  }

  ${styles}
`;
/* eslint-enable react/no-unused-prop-types */
export function InternalTab({ tabid, tablabel, isActive, onClick = () => null, canDelete, onDelete = () => null, tabstyles, render, }) {
    let className = 'tab-list-item';
    // use tab identifier if given (higher priority)
    if (isActive) {
        className += ' tab-list-active';
    }
    const clickHandler = useCallback((e) => {
        onClick({ ...e, tablabel, tabid });
    }, [onClick, tablabel, tabid]);
    const deleteHandler = useCallback((e) => {
        // stop propagation here to not have set it
        // as active tab too (via tab click event triggering)
        e.stopPropagation();
        onDelete({ ...e, tablabel, tabid });
    }, [onDelete, tablabel, tabid]);
    return (_jsxs("li", { className: className, onClick: clickHandler, css: styles(tabstyles), children: [canDelete && _jsx(DeleteButton, { onDelete: deleteHandler }), render
                ? render({ isActive, title: tablabel || '', id: tabid })
                : tablabel] }));
}
export default function Tab(props) {
    return _jsx(_Fragment, { children: props.children });
}
